export const getEnvironment = (): 'local' | 'development' | 'production' => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('192.168.')) {
    return 'local';
  }

  if (hostname.includes('-dev')) {
    return 'development';
  }

  return 'production';
};

export const isSentryEnabled = (): boolean => {
  const env = getEnvironment();

  return env !== 'local';
};
